module.exports = __webpack_public_path__ + "img/sample-03.aeea854c.png";